import styled from "styled-components";
import COLORS from "styles/colors";

export const Container = styled.div`
  width: 100%;
  background: ${({ bg }) => bg};
  color: ${({ fontColor }) => fontColor};
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  align-items: center;
  padding-bottom: 5rem;
  overflow: hidden;
  position: relative;

  img {
    &.ellipse6 {
      position: absolute;
      left: 0;
      top: -100px;
    }
    &.ellipse5 {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    @media all and (max-width: 567px) {
      display: none;
    }
  }
  .wrapper {
    margin: 8.5rem 10rem;
    width: 100%;
    margin-bottom: 0;
    text-align: center;
    @media all and (max-width: 567px) {
      margin: 5rem 2rem;
    }

    .header {
      span {
        font-size: 1.4rem;
        /* line-height: 1.7rem; */
        letter-spacing: 0.15em;
      }
      .title {
        font-size: 3.6rem;
        /* line-height: 4.5rem; */
        margin-top: 1.2rem;
        margin-bottom: 6.4rem;
      }
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      justify-content: space-evenly;
      width: 100%;
    }
  }
`;

export const SlideContainer = styled.div`
  width: 100%;

  .slide-container {
    width: 50%;
    margin: 0 auto;
    .slick-slider.slick-initialized {
      button {
        background: rgba(218, 180, 255, 0.1);
        height: 50px;
        width: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${COLORS.white};
        font-size: 2.4rem;
        transform: none;
        ::before {
          content: "";
        }
      }
    }
    .slick-slider.slick-initialized .slick-dots {
      > li button {
        border: 1px solid #fff;
        width: 5px;
        height: 5px;
        font-size: 0;
      }
      .slick-active button {
        background: #fff;
      }
    }

    @media all and (max-width: 1024px) {
      width: 100%;
    }
  }
`;

export const TestminonialWrapper = styled.div`
  padding: 0 9rem;

  @media all and (max-width: 768px) {
    padding: 0 1rem;
  }
  .testimonial-wrap {
    /* width: 100%; */
    background: rgba(218, 180, 255, 0.1);
    border: 1px solid rgba(248, 241, 255, 0.4);
    border-radius: 1.2rem;
    /* width: 100%; */
    margin: 0 auto;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 36px;
    .testimony-wrap {
      padding: 7rem 6rem;

      @media all and (max-width: 768px) {
        padding: 4rem;
        
      }

      .testimonial-text {
        font-size: 1.5rem;
        line-height: 24px;
        max-width: 600px;
      }
    }
    .person-deets {
      margin: 3.6rem 0;
      display: flex;

      font-size: 1.2rem;
      align-items: flex-end;
      letter-spacing: 0.15em;
      .name-country {
        margin: 0 10px;
      }
      img {
        width: 36px;
        height: 36px;
        vertical-align: bottom;
        border-radius: 50%;
      }
    }
  }
`;
